import { Navigate } from 'react-router-dom';

import { ROUTE_PATHS } from '@dmp/constant';

export const LandingPage = () => {
  return <Navigate to={ROUTE_PATHS.DATA_CATALOG} replace={true} />;
};
